import React from "react";
import ReactDOM from "react-dom/client";
import "./sass/combine-styles.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Router>
      {/* REMOVE STRICTMODE TO AVOID DOUBLE CONSOLE.LOG 
      ALSO REMOVE STRICTMODE TO AVOID HELMET SEO ERROR */}
      <App />
    </Router>
  // </React.StrictMode>
);
// TODO ADD HELMET
// TODO DOWNLOAD AVERNIR FONT
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
